import { faGraduationCap, faScreenUsers, faUserShield, faUserTie } from '@fortawesome/pro-regular-svg-icons';
import type { SelectOption } from '@tryhackme/thm-ui-components';

import { UserInstitutionType, UserOccupation, UserOccupationTeam } from 'src/common/constants/user';
import * as yup from 'yup';
import type { OccupationDetailsProps } from './occupation-details.types';

export const occupationOptions: OccupationDetailsProps[] = [
  {
    icon: faGraduationCap,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Student / Intern',
      name: 'occupation-options',
      value: UserOccupation.STUDENT,
      disabled: false,
    },
  },
  {
    icon: faUserShield,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Cyber Practitioner',
      name: 'occupation-options',
      value: UserOccupation.CYBER_PRACTITIONER,
      disabled: false,
    },
  },
  {
    icon: faUserShield,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'IT Practitioner',
      name: 'occupation-options',
      value: UserOccupation.IT_PRACTITIONER,
      disabled: false,
    },
  },
  {
    icon: faScreenUsers,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Manager',
      name: 'occupation-options',
      value: UserOccupation.MANAGER,
      disabled: false,
    },
  },
  {
    icon: faUserTie,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Director',
      name: 'occupation-options',
      value: UserOccupation.DIRECTOR,
      disabled: false,
    },
  },
  {
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Other',
      name: 'occupation-options',
      value: UserOccupation.OTHER,
      disabled: false,
    },
  },
];

export const OCCUPATION_OPTIONS: SelectOption[] = [
  { id: '1', label: 'Choose role', value: UserOccupation.NONE },
  { id: '2', label: 'Student / Intern', value: UserOccupation.STUDENT },
  { id: '3', label: 'Cyber Practitioner', value: UserOccupation.CYBER_PRACTITIONER },
  { id: '4', label: 'IT Practitioner', value: UserOccupation.IT_PRACTITIONER },
  { id: '5', label: 'Manager', value: UserOccupation.MANAGER },
  { id: '6', label: 'Director', value: UserOccupation.DIRECTOR },
  { id: '7', label: 'Other', value: UserOccupation.OTHER },
];

export const OCCUPATION_TEAM_OPTIONS: SelectOption[] = [
  { id: '1', label: 'Choose team', value: UserOccupationTeam.NONE },
  { id: '2', label: 'Compliance', value: UserOccupationTeam.COMPLIANCE },
  { id: '3', label: 'Data Science', value: UserOccupationTeam['DATA-SCIENCE'] },
  { id: '4', label: 'Engineering', value: UserOccupationTeam.ENGINEERING },
  { id: '5', label: 'IT', value: UserOccupationTeam.IT },
  { id: '6', label: 'Operations', value: UserOccupationTeam.OPERATIONS },
  { id: '7', label: 'QA/Testing', value: UserOccupationTeam.QA_TESTING },
  { id: '8', label: 'Sales Engineering', value: UserOccupationTeam.SALES_ENGINEERING },
  { id: '9', label: 'Security', value: UserOccupationTeam.SECURITY },
  { id: '10', label: 'Support/Help Desk', value: UserOccupationTeam.SUPPORT_HELP_DESK },
  { id: '11', label: 'Technical Marketing', value: UserOccupationTeam.TECHNICAL_MARKETING },
  { id: '12', label: 'Other', value: UserOccupationTeam.OTHER },
];

export const INSTITUTION_TYPE_OPTIONS: SelectOption[] = [
  { id: '1', label: 'Choose type', value: UserInstitutionType.NONE },
  { id: '2', label: 'University', value: UserInstitutionType.UNIVERSITY },
  { id: '3', label: 'College', value: UserInstitutionType.COLLEGE },
  { id: '4', label: 'School', value: UserInstitutionType.SCHOOL },
];

export const occupationDetailsFormValidationSchema = yup.object({
  occupation: yup.string(),
  institutionType: yup.string(),
  institutionName: yup.string(),
  team: yup.string(),
  fullName: yup.string(),
  businessEmail: yup.string().email(),
  phoneNumber: yup.string(),
  companyName: yup.string(),
  jobTitle: yup.string(),
});

export type OccupationDetailsFromInputs = yup.InferType<typeof occupationDetailsFormValidationSchema>;

export const DEFAULT_INPUT_VALUES: OccupationDetailsFromInputs = {
  occupation: '',
  businessEmail: '',
  fullName: '',
  institutionType: '',
  institutionName: '',
  team: '',
  jobTitle: '',
  companyName: '',
  phoneNumber: '',
} as const;

export const validEmailRegularExpression =
  // eslint-disable-next-line max-len, unicorn/better-regex, no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
